<template>
    <div class="w-full p-0">
      <div v-if="fileNote"> 
        <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                 NOTE: Please make sure the documents/files you upload are not password protected and free from any restrictions to use or process.                    
        </vs-alert>    <br/>
      </div>
      <div v-if="success && successMsg" class="success_msg"> 
        <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" active="true">
          <svg class="mr-2" id="Group_76375" data-name="Group 76375" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24.004 24.004">
            <circle id="Ellipse_574" data-name="Ellipse 574" cx="9.002" cy="9.002" r="9.002" transform="translate(2.4 2.529)" fill="#fff"/>
            <g id="check">
              <g id="Group_8119" data-name="Group 8119">
                <path id="Path_34467" data-name="Path 34467" d="M12,0A12,12,0,1,0,24,12,12.049,12.049,0,0,0,12,0ZM10.55,17.461,5.294,12.205l1.989-1.989,3.359,3.359,6.743-6.13,1.893,2.081Z" fill="#27a438"/>
              </g>
            </g>
          </svg>
          {{ successMsg }}                    
        </vs-alert>    
      </div>
      <div v-if="ShowMessage && messag"> 
        <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                 NOTE: {{messag}}                   
        </vs-alert>    <br/>
      </div>
    
    </div>
    </template>
    
    <script>
    export default {
        props: {
            fileNote:{ type: Boolean, default: true}, 
            success:{ type: Boolean, default: false}, 
            successMsg:{ type: String, default: ''}, 
            ShowMessage:{ type: Boolean, default: false}, 
            messag:{ type: String, default: ''}
        },
        data() {
            return {
            };
        },
        mounted(){
        },
        methods: {
        }
    }
    </script>
    
    